import { useCallback, useState } from 'react';
import {
  assignOrderResponsibleUser,
  deleteOrderResponsibleUser,
  getOrderResponsibleUsersList
} from 'services/responsibleUsers.service';
import useUsersState from 'state/useUsersState';
import { IbackofficeUserData } from 'types/configuration.types';
import { IResponsibleUserData } from 'types/responsibleUser.types';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useBordResponsibleUserData = (orderId?: number) => {
  const { users } = useUsersState();

  const [responsibleUserList, setResponsibleUserList] = useState<IResponsibleUserData[]>([]);

  const [isLoading, setIsLoading] = useState(false);

  const getResponsibleUserList = useCallback(() => {
    if (!orderId) return;
    setIsLoading(true);
    getOrderResponsibleUsersList(orderId)
      .then(response => {
        if (response) setResponsibleUserList(response);
      })
      .catch(() => {
        displayErrorNotification();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [orderId]);

  const assignOrderResponsable = async (user: IbackofficeUserData) => {
    if (!orderId || !user) return;
    setIsLoading(true);

    try {
      const orderBody = {
        orderId: Number(orderId),
        userId: user.id
      };
      const response = await assignOrderResponsibleUser(orderBody);

      if (response) getResponsibleUserList();
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  const deleteOrderResponsable = async (responsibleId?: number, userName?: string) => {
    if (!orderId || !responsibleId) return;
    setIsLoading(true);
    try {
      await deleteOrderResponsibleUser(responsibleId);
      setResponsibleUserList(responsibleUserList.filter(user => user.id !== responsibleId));

      getResponsibleUserList();

      displaySuccessNotification({
        customJSXMessage: <div>Se eliminó al responsable {userName} de esta orden exitosamente</div>
      });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    responsibleUserList,
    userList: users,
    isLoading,
    getResponsibleUserList,
    assignOrderResponsable,
    deleteOrderResponsable
  };
};
